import { Component, inject } from '@angular/core';
import { SurveyRenderControllerStore } from '../../render-store/render.store';
import { SafeScriptComponent } from '../../script-injector/safe-script/safe-script.component';

@Component({
  selector: 'lib-survey-error-occured',
  imports: [SafeScriptComponent],
  templateUrl: './survey-error-occured.html',
  styleUrl: './survey-error-occured.css',
})
export class SurveyErrorOccured {
  renderStore = inject(SurveyRenderControllerStore);
}
